import { useEffect } from 'react';
export function useResizeObserver(ref, // note: you'll want to memoize this function or the listener will rebind each render
onResize) {
    const observable = ref.current;
    useEffect(()=>{
        if (!ref.current) {
            return;
        }
        const observer = new ResizeObserver((entries, ob)=>requestAnimationFrame(()=>onResize(entries, ob)));
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        onResize,
        observable,
        ref
    ]);
}
